import { Injectable } from '@angular/core';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { AngularFirestore } from '@angular/fire/firestore';
import { Platform } from '@ionic/angular';
import { User } from 'src/app/classes/user';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  user= new User;
  constructor(
   // private fcm:FCM,
    private db:AngularFirestore,
    private platform: Platform,
    private router:Router
  ) {}



  subscribeToTopic(topic){
    FCM.subscribeToTopic(topic);
  }
  unSubscribeToTopic(topic){
    FCM.unsubscribeFromTopic(topic);
  }

  async getToken() {
    if (this.platform.is('android')) {
      FCM.getToken().then(token => {
        this.db.collection("users").doc(localStorage.getItem("uid")).update({token:token});
      }).catch(err=>{
        console.log("error get token: "+err);
      });
    }
    if (this.platform.is('ios')) {
      FCM.requestPushPermission().then(res=>{
        console.log(res);
      }).catch(err=>{
        console.log(err); 
      });
      FCM.hasPermission().then(res=>{
        console.log(res);
        FCM.getToken().then(token => {
          console.log(token);
          this.db.collection("users").doc(localStorage.getItem("uid")).update({token:token});
        }).catch(err=>{
          console.log("error get token: "+err);
        });  
      });
    }
  }

  refreshToken(){
    FCM.onTokenRefresh().subscribe(token => {
      console.log(token);
      this.db.collection("users").doc(localStorage.getItem("uid")).update({token:token});
    });
  }
  suscribeOnNotifications(){
    if(this.platform.is("ios")||this.platform.is("android")){
      FCM.onNotification().subscribe(data => {
        console.log(data);
        if(data.wasTapped){
          this.router.navigateByUrl("puntos-verdes");
          console.log("Received in background");
        } else {
          this.router.navigateByUrl("mi-cuenta");
          console.log("Received in foreground");
        };
      });
    }
  }
  
}
